import React from 'react';

const ArticleCta = ({ cta }) => {

  console.log('CTA Data in ArticleCta:', cta);  
  if (!cta) {
    return null;
  }

  // Destructure the values from the cta object
  const { Title, Description, ButtonText, ButtonURL } = cta;

  return (
    <div className="bg-gradient-to-r from-orange-100 to-yellow-200 p-10 sm:p-18 text-center rounded-lg">
      <h2 className="text-3xl font-bold text-black mb-4">{Title}</h2>
      <p className="text-md text-black mb-6">{Description}</p>
      {ButtonText && ButtonURL && (
        <a 
          href={ButtonURL} 
          className="bg-[#FFA201] text-black font-semibold px-10 py-3 rounded-full hover:bg[#d08504] transition duration-300"
        >
          {ButtonText}
        </a>
      )}
    </div>
  );
};

export default ArticleCta;